import {
  FETCH_PROFILE_REQUEST,
  FETCH_PROFILE_SUCCESS,
  FETCH_PROFILE_FAILURE
} from '../../../Constants/actionTypes';

import { API_USER_PROFILE } from '../../../Constants/apiUrls';
import { fetchProfileData } from '../../../Constants/apiService';







export const fetchProfile = () => async (dispatch, getState) => {
  dispatch({ type: FETCH_PROFILE_REQUEST });


  const state = getState();
  const accessToken = state.auth.accessToken;

  try {
    const data = await fetchProfileData(accessToken);
    dispatch({ type: FETCH_PROFILE_SUCCESS, payload: data });
  } catch (error) {
    let errorMessage;
    if (error.message === 'Failed to fetch' || error.message.includes('NetworkError')) {
      errorMessage = 'Server is currently down. Please try again later.';
    } else {
      errorMessage = error.message;
    }
    dispatch({ type: FETCH_PROFILE_FAILURE, payload: errorMessage });
  }
};
